import { observable, action, set, computed } from "mobx";

class MlsService {
  /**
   * @property {number}
   */
  @observable mlsServiceId = 0;

  /**
   * @property {string}
   */
  @observable name = "";

  /**
   * @property {string}
   */
  @observable state = "";

  /**
   * @returns {string}
   */
  @computed
  get displayName() {
    return `${this.state}, ${this.name}`;
  }

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
export default MlsService;
